import { Controller } from '@hotwired/stimulus'
import $ from "jquery"
import select2 from 'select2'

export default class extends Controller {
  static values = { tags: Boolean }

  connect() {
    select2($)

    let options = {}

    if (this.tagsValue) {
      options.tags = true
    }

    $(this.element).select2(options)
  }
}
